// extracted by mini-css-extract-plugin
module.exports = {"formulaContainer":"StaffReportTitle_formulaContainer__2i9xW"};